import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

/**
 * Win11 tonal filled "text" buttons — never transparent.
 * AppButton maps text → this look via theme overrides.
 */
const { text, info, secondary, grey } = colors;
const { size } = typography;

const tonalBg = (colors.background as { tonal?: string }).tonal || "rgba(0, 0, 0, 0.04)";
const tonalHover =
  (colors.background as { tonalHover?: string }).tonalHover || "rgba(0, 0, 0, 0.07)";

const buttonText = {
  base: {
    backgroundColor: tonalBg,
    minHeight: pxToRem(32),
    color: text.main,
    boxShadow: "none",
    borderRadius: pxToRem(4),
    padding: `${pxToRem(5)} ${pxToRem(16)}`,

    "&:hover": {
      backgroundColor: tonalHover,
      boxShadow: "none",
    },

    "&:focus": {
      boxShadow: "none",
      backgroundColor: tonalHover,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.92,
      boxShadow: "none",
    },

    "&:disabled": {
      boxShadow: "none",
      backgroundColor: grey[100],
      color: text.disabled,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(14)}`,
    fontSize: size.xs,
    borderRadius: pxToRem(8),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,
    borderRadius: pxToRem(12),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    color: colors.primary.main,
    backgroundColor: tonalBg,

    "&:hover": {
      color: colors.primary.dark,
      backgroundColor: tonalHover,
    },

    "&:focus:not(:hover)": {
      color: colors.primary.dark,
      boxShadow: "none",
      backgroundColor: tonalHover,
    },
  },

  secondary: {
    color: secondary.main,
    backgroundColor: grey[100],

    "&:hover": {
      color: secondary.focus,
      backgroundColor: grey[200],
    },

    "&:focus:not(:hover)": {
      color: secondary.focus,
      boxShadow: "none",
      backgroundColor: grey[200],
    },
  },

  success: {
    color: colors.success.dark,
    backgroundColor: "rgba(4, 120, 87, 0.1)",

    "&:hover": {
      color: colors.success.dark,
      backgroundColor: "rgba(4, 120, 87, 0.16)",
    },

    "&:focus:not(:hover)": {
      color: colors.success.dark,
      boxShadow: "none",
    },
  },

  warning: {
    color: colors.warning.dark,
    backgroundColor: "rgba(180, 83, 9, 0.1)",

    "&:hover": {
      color: colors.warning.dark,
      backgroundColor: "rgba(180, 83, 9, 0.16)",
    },

    "&:focus:not(:hover)": {
      color: colors.warning.dark,
      boxShadow: "none",
    },
  },

  error: {
    color: colors.error.dark,
    backgroundColor: "rgba(185, 28, 28, 0.1)",

    "&:hover": {
      color: colors.error.dark,
      backgroundColor: "rgba(185, 28, 28, 0.16)",
    },

    "&:focus:not(:hover)": {
      color: colors.error.dark,
      boxShadow: "none",
    },
  },

  info: {
    color: info.dark,
    backgroundColor: "rgba(3, 105, 161, 0.1)",

    "&:hover": {
      color: info.dark,
      backgroundColor: "rgba(3, 105, 161, 0.16)",
    },

    "&:focus:not(:hover)": {
      color: info.dark,
      boxShadow: "none",
    },
  },
};

export default buttonText;
